module.exports = __webpack_public_path__ + "static/slide1-dfaf2d9e6e677867f2d62e21ea06c7a5.png";